'use client';

import { SvgChevrondown } from '@common/icon';
import { useState } from 'react';

interface FilterSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function FilterSection({
  title,
  defaultOpen = true,
  children,
}: FilterSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="flex flex-col gap-12">
      <button
        type="button"
        className="flex items-center justify-between px-12"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="font-700 text-Gray-900 typo-body3">{title}</span>
        <SvgChevrondown
          className={`size-16 text-Gray-900 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen ? (
        <div className="flex flex-col gap-12 px-16">{children}</div>
      ) : null}
    </div>
  );
}
